import { Switch, Button } from "@mui/material";
import { useMultiuserContext } from "@solidwhite/multiuser";
import { useEffect, useState } from "react";
import { fetchAuthSession } from "aws-amplify/auth";
import { Hub } from "aws-amplify/utils";
import { useSearchParam } from "react-use";

const SynchToggle = () => {
  const { connect, disconnect, createRoom, connected, spectating } = useMultiuserContext();

  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const updateRoomPermission = async () => {
      try {
        const { tokens } = await fetchAuthSession();
        const userGroups = tokens?.idToken?.payload["cognito:groups"];

        setShowButton(userGroups?.includes("Admin") || userGroups?.includes("Team") || false);
      } catch {
        setShowButton(false);
      }
    };

    const cancelAuthListener = Hub.listen("auth", ({ payload }) => {
      if (payload.event === "signedIn" || payload.event === "signedOut") {
        updateRoomPermission();
      }
    });

    updateRoomPermission();

    return () => cancelAuthListener();
  }, []);

  const [roomName, setRoomName] = useState("");

  const [connecting, setConnecting] = useState(false);

  const join = useSearchParam("join");

  useEffect(() => {
    if (join && !connected) {
      connect(join);
    }
  }, []);

  useEffect(() => {
    if (!connected) {
      setRoomName("");
    }
  }, [connected]);

  if (spectating) return null;

  const handleCopyClick = () => {
    navigator.clipboard.writeText(roomName);
    alert(`Copied to clipboard: ${roomName}`);
  };

  const handleCreateClick = async () => {
    const { tokens } = await fetchAuthSession();

    setConnecting(true);
    try {
      const roomName = await createRoom(tokens.idToken.toString());
      setRoomName(`${window.location.origin}${window.location.pathname}?join=${roomName}`);
      navigator.clipboard.writeText(`${window.location.origin}${window.location.pathname}?join=${roomName}`);
      alert(`Copied to clipboard: ${window.location.origin}${window.location.pathname}?join=${roomName}`);
    } catch (e) {
      console.error(e);
      setConnecting(false);
    }
  };

  if (!showButton) return null;

  return (
    <div>
      {roomName && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background: "white",
              padding: "10px",
            }}
          >
            {roomName}
          </div>

          <div style={{ width: "1vw" }}></div>
          <Button variant="contained" onClick={handleCopyClick} color="primary">
            COPY
          </Button>
        </div>
      )}
      {!roomName && (
        <div>
          {connecting ? (
            <Button variant="contained" disabled color="primary">
              CONNECTING
            </Button>
          ) : (
            <Button variant="contained" onClick={handleCreateClick} color="primary">
              CREATE ROOM
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default SynchToggle;
